import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng2selectObject } from 'app/dto/ng2selectObject';
import { User } from 'app/models/user';
import { LocationService } from 'app/services/location.service';
import { ServiceAreaService } from 'app/services/serviceArea.service';

import swal from "bootstrap-sweetalert";
import * as _ from 'lodash';

import { BsModalRef } from "ngx-bootstrap";
import { UserService } from 'app/services/user.service';

@Component({
  templateUrl: './user-update.component.html'
})
export class UserUpdateComponent implements OnInit, OnDestroy {

  //!!!WARNING!!! Внешнее поле передоваемое сервисом модальных окон !!!WARNING!!!
  public userForEdit: User;

  private _lock: Boolean;
  private _errorState: UserUpdateComponent.ErrorState = UserUpdateComponent.ErrorState.None;
  private ErrorStateEnum = UserUpdateComponent.ErrorState;
  private _serviceAreaSelectItems: Ng2selectObject[];
  private _serviceAreaActiveItems: any[] = [];

  //Поля для редактирования пользователя
  private _isWritable: boolean;
  private _canCancelCalls: boolean;
  private _isAllowAllServiceArea: boolean;
  private _isLocked: boolean;
  private _name: string;

  constructor(private serviceAreaService: ServiceAreaService,
    private locationService: LocationService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public updateUserModal: BsModalRef
    ) { }

  ngOnDestroy(): void {
    swal.close();
  }

  ngOnInit() {
    this.loadData();
  }

  private loadData(): void {
    if(this.userForEdit === undefined)
    {
      swal({
        title: 'Ошибка',
        text: 'Неизвестный пользователь',
        type: 'error'
      }, () => {
          this.close();
      });
    }

    this._name = this.userForEdit.name;
    this._isWritable = (this.userForEdit.permissions & User.Permissions.Write) == User.Permissions.Write;
    this._isLocked = this.userForEdit.status == User.Status.Locked;
    this._isAllowAllServiceArea = this.userForEdit.isAllowedAllServiceArea;
    this._canCancelCalls = this.userForEdit.canCancelCalls;

    this.serviceAreaService.getServiceAreas()
            .subscribe(serviceAreas => {
                this._serviceAreaSelectItems = _.map(serviceAreas, function(obj) { return new Ng2selectObject(obj.id.toString(), obj.name) });
                this._serviceAreaSelectItems
                .filter(selObj => this.userForEdit.serviceAreaIds.includes(Number(selObj.id)))
                .forEach(selObj => this._serviceAreaActiveItems.push({id: selObj.id, text: selObj.text}));
            }, err => {
                this._errorState = UserUpdateComponent.ErrorState.UnknownError;
                swal({
                    title: 'Ошибка',
                    text: 'Не удалось получить территории обслуживания. Попробуйте снова',
                    type: 'error',
                    confirmButtonText: 'Попробовать еще раз'
                }, () => {
                    this.loadData();
                });
            });
  }


  private close() {
    this.updateUserModal.hide();
  }

  private removeServiceAreaItem(serviceArea: Ng2selectObject): void {
    _.remove(this._serviceAreaActiveItems, function (item) { return item.id == serviceArea.id; });
  }

  private onSubmit(updateUserForm: NgForm) {
    if (updateUserForm.valid || !this._lock) {
        this._lock = true;
        let user: User = new User();
        user.id = this.userForEdit.id;
        user.name = this._name;
        user.role = User.Role.Manager;
        user.permissions = this._isWritable ? User.Permissions.Read | User.Permissions.Write : User.Permissions.Read;
        user.isAllowedAllServiceArea = this._isAllowAllServiceArea;
        user.canCancelCalls = this._canCancelCalls;
        user.status = this._isLocked ? User.Status.Locked : User.Status.Active;
        user.serviceAreaIds = this._isAllowAllServiceArea ? [] : _.map(this._serviceAreaActiveItems, "id");
        this.userService.patchUser(user).subscribe(user => {
            swal({
              title: 'Ок',
              text: 'Пользователь успешно обновлён',
              type: 'success'
            }, () => this.close());
        }, err => {
            swal('Ошибка сохранения', 'При сохранении пользователя произошла ошибка', 'error');
            this._lock = false;
        });
    }
  }

}


export namespace UserUpdateComponent {

  export enum ErrorState {
      /**
      * Нет ошибок
      */
      None,
      /**
       * Сервер не может предоставить данные по локации или территории обслуживания
       */
      NoData,
      /**
       * Другая ошибка
       */
      UnknownError
  }

}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/admin/user/update/user-update.component.ts